import React from 'react';
import css from '../styles/AuthWrap.module.css';


const AuthWrapComponent = ({title, children}) => {
  return (
      <div className={css.wrap}>
        <h1 className={css.title}>{title}</h1>
        {children}
      </div>
  );
};

export default AuthWrapComponent;